import React, { useState } from "react";
import EditContactInfo from "./EditContactInfo";

const blankContactInfo = { type: "", value: "" };

// The "add a contact detail" affordance — a button that expands into a blank row editor. Mirrors the
// publications editor's new-record line.
function NewContactInfoLine({ onNewContactInfo, disabled = false }) {
  const [adding, setAdding] = useState(false);

  const toggleAdding = () => {
    setAdding((prev) => !prev);
  };

  const confirmAdding = (contactInfo) => {
    setAdding(false);
    onNewContactInfo(contactInfo);
  };

  return adding ? (
    <EditContactInfo
      contactInfo={blankContactInfo}
      onConfirm={confirmAdding}
      onCancel={toggleAdding}
      disabled={disabled}
    />
  ) : (
    <tr>
      <td colSpan="999">
        <button onClick={toggleAdding} type="button" className="btn btn-sm btn-outline-primary" disabled={disabled}>
          New contact detail
        </button>
      </td>
    </tr>
  );
}

export default NewContactInfoLine;
